import { PassageSubCategoryEnum, PassageTypeEnum } from '__generatedTypes__/globalTypes'

export const PASSAGE_CATEGORIES: Record<
  PassageTypeEnum,
  {
    id: PassageTypeEnum
    title: string
    subCategories: Array<{
      id: PassageSubCategoryEnum
      title: string
    }>
  }
> = {
  [PassageTypeEnum.Humanities]: {
    id: PassageTypeEnum.Humanities,
    title: 'Humanities',
    subCategories: [
      {
        id: PassageSubCategoryEnum.Architecture,
        title: 'Architecture',
      },
      {
        id: PassageSubCategoryEnum.Art,
        title: 'Art',
      },
      {
        id: PassageSubCategoryEnum.Dance,
        title: 'Dance',
      },
      {
        id: PassageSubCategoryEnum.Ethics,
        title: 'Ethics',
      },
      {
        id: PassageSubCategoryEnum.Literature,
        title: 'Literature',
      },
      {
        id: PassageSubCategoryEnum.Music,
        title: 'Music',
      },
      {
        id: PassageSubCategoryEnum.Philosophy,
        title: 'Philosophy',
      },
      {
        id: PassageSubCategoryEnum.PopularCulture,
        title: 'Popular Culture',
      },
      {
        id: PassageSubCategoryEnum.Religion,
        title: 'Religion',
      },
      {
        id: PassageSubCategoryEnum.Theater,
        title: 'Theater',
      },
      {
        id: PassageSubCategoryEnum.StudiesOfDiverseCultures,
        title: 'Studies of Diverse Cultures',
      },
    ],
  },
  [PassageTypeEnum.SocialSciences]: {
    id: PassageTypeEnum.SocialSciences,
    title: 'Social Sciences',
    subCategories: [
      {
        id: PassageSubCategoryEnum.Anthropology,
        title: 'Anthropology',
      },
      {
        id: PassageSubCategoryEnum.Archaeology,
        title: 'Archaeology',
      },
      {
        id: PassageSubCategoryEnum.Economics,
        title: 'Economics',
      },
      {
        id: PassageSubCategoryEnum.Education,
        title: 'Education',
      },
      {
        id: PassageSubCategoryEnum.Geography,
        title: 'Geography',
      },
      {
        id: PassageSubCategoryEnum.History,
        title: 'History',
      },
      {
        id: PassageSubCategoryEnum.Linguistics,
        title: 'Linguistics',
      },
      {
        id: PassageSubCategoryEnum.PoliticalScience,
        title: 'Political Science',
      },
      {
        id: PassageSubCategoryEnum.PopulationHealth,
        title: 'Population Health',
      },
      {
        id: PassageSubCategoryEnum.Psychology,
        title: 'Psychology',
      },
      {
        id: PassageSubCategoryEnum.Sociology,
        title: 'Sociology',
      },
      {
        id: PassageSubCategoryEnum.StudiesOfDiverseCultures,
        title: 'Studies of Diverse Cultures',
      },
    ],
  },
}
